import { Fragment, Ref } from 'react';
import { ShopTypes } from '~/lib/data-contract';
import { useTranslations } from '~/services/umbraco/hooks';
import { AccordionItem, AccordionItemRef } from '~/shared/components/Accordion';
import { Text } from './styled';

const ProductFAQ = ({
    product,
    ref,
}: {
    product?: ShopTypes.ProductQueryProduct;
    ref?: Ref<AccordionItemRef>;
}) => {
    const { translate } = useTranslations();

    if (!product?.productFAQ) {
        return null;
    }

    const entries = product.productFAQ
        .split('\n')
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => {
            const [heading, ...rest] = line.split(';');
            return { heading, text: rest.join(';').trim() };
        });

    if (!entries.length) {
        return null;
    }

    return (
        <AccordionItem ref={ref} id="faq" header={translate('product.faqTitle')}>
            {entries.map(({ heading, text }, index) => (
                <Fragment key={index}>
                    <Text isTitle>{heading}</Text>
                    {text ? <Text>{text}</Text> : null}
                </Fragment>
            ))}
        </AccordionItem>
    );
};

export default ProductFAQ;
